module.exports = function getResource(label, vars = []) {
    let resources = {
        preSelectedAnswersNotification: 'Toute réponse pré-sélectionnée est basée sur les renseignements que vous avez fournis par le passé. Veuillez les mettre à jour si nécessaire.',
        gotItButtonLabel: 'C’est compris!'
    };

    return resources[label];
};
